export const AccrualPeriodFrequency = Object.freeze({
  Year: 'Year', // 0
  Month: 'Month', // 1
  PayPeriod: 'Pay Period', // 2
  Week: 'Week', // 3
  Day: 'Day', // 4
  Hour: 'Hour', // 5
});

export const AccrualEmployeeStartInterval = Object.freeze({
  Hired: 'Hired',
  CurrentPayPeriod: 'CurrentPayPeriod',
  LastPayPeriod: 'LastPayPeriod',
  DateSelected: 'DateSelected',
  NotEnrolled: 'NotEnrolled',
});

export const hoursLabels = Object.freeze({
  Regular: 'Regular/PTO',
  Overtime: 'OT',
  Doubletime: 'Double Time',
  Amounts: 'Amounts',
});
